// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Skeleton } from '@/components/ui/Skeleton';

export function SidebarProjectSkeleton() {
  return (
    <div className="pl-6 pr-3 py-1.5 space-y-2">
      <Skeleton className="h-3 w-3/4" />
      <Skeleton className="h-3 w-1/2" />
    </div>
  );
}
